import ScoreTableCard from "./ScoreTableCard";
import MissingPlayerTable from "./MissingPlayerTable";
import GameStrongPoint from "./GameStrongPoint";
import React, {useEffect, useState} from "react";
import PlayGround from "./PlayGround";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_GAME_ANALYSIS_DATA_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";

const BUTTON_LIST = [
  {name: "전체평균", value: 1},
  {name: "최근3경기", value: 2},
  {name: "홈/원정", value: 3},
]

const LineupComponent = ({dataId, analysisType}) => {
  const [playerDataDetails, setPlayerDataDetails] = useState({});

  const [homeTeamData, setHomeTeamData] = useState({});
  const [awayTeamData, setAwayTeamData] = useState({});
  const [buttonValue, setButtonValue] = useState(BUTTON_LIST[0].value);
  const [option, setOption] = useState(1);
  const [refreshDate, setRefreshDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getLineUpData();
  }, [dataId, analysisType, option]);


  const getLineUpData = () => {
    // 라인업 정보 받아오기
    getFetcherAnalysis().get(GET_GAME_ANALYSIS_DATA_API + `?dataId=${dataId}&opt=${option}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data.length===0 || (data[0].HOME.length === 0 && data[0].AWAY.length === 0)) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setHomeTeamData(data[0].HOME);
            setAwayTeamData(data[0].AWAY);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => {
          console.log(err);
        }
    );
  }


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }

  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="w-full h-full">
        {/*버튼영역*/}
        <div
            className="flex flex-row w-full h-8 whitespace-nowrap my-2 pl-0.5"
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
        >
          {BUTTON_LIST.map((button) => {
            return <button
                key={button.name}
                className={neverLandUtils.classNames(buttonValue === button.value ? "bg-lime-400" : "bg-white ring-1 ring-gray-300 shadow-md", "px-3 py-1 mr-2 rounded-lg")}
                onClick={() => {
                  setButtonValue(button.value);
                  setOption(button.value);
                }}
            >
              {button.name}
            </button>
          })}
        </div>

        {/* <-- 경기장 --> */}
        <PlayGround homeTeamData={homeTeamData}
                    awayTeamData={awayTeamData}
                    dataId={dataId}
                    playerDataDetails={playerDataDetails}/>

        {/* <-- 점수 카드 --> */}
        <ScoreTableCard homeTeamData={homeTeamData}
                        awayTeamData={awayTeamData}
                        dataId={dataId}
                        setPlayerDataDetails={setPlayerDataDetails}
                        refreshDate={refreshDate}
                        buttonValue={buttonValue}
        />

        {/* <-- 결장자 --> */}
        <div className="w-full flex flex-col mt-7">
          <p className="text-2xl">결장자</p>
          <div className="w-full border-t-2 border-gray-900 my-1"/>
          <MissingPlayerTable teamData={homeTeamData} team={"home"}/>
          <MissingPlayerTable teamData={awayTeamData} team={"away"}/>
        </div>

        {/* <-- 스타일 / 강점 --> */}
        <div className="w-full flex flex-col mt-7">
          <p className="text-2xl">강점 & 약점 & 스타일</p>
          <div className="w-full border-t-2 border-gray-900 my-1"/>
          <GameStrongPoint teamData={homeTeamData} team={"home"}/>
          <GameStrongPoint teamData={awayTeamData} team={"away"}/>
        </div>
      </div>
  )
}
export default LineupComponent;